<ng-template #otherCoverage>
  <div fxLayout="row" fxFlexFill *ngIf="!(selfPay.isPEBB && selfPay.isCobraInitial)">
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Are you covered by another group medical plan?</label>
      <yes-no [name]="'coveredByOtherMedical' + idx" style="width: auto;" orientation="horizontal-list"
        [stretch]="false" [(ngModel)]="currentDependent.coveredByOtherMedicalInd"></yes-no>
    </kendo-formfield>
    <div class="form-inline">
      <date-picker #coveredByOtherMedicalDate="ngModel" [name]="'coveredByOtherMedicalDate' + idx"
        [(ngModel)]="currentDependent.coveredByOtherMedicalDate">
        <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
      </date-picker>
    </div>
  </div>
  <div *ngIf="(selfPay.isSEBB && requestType.selfPayTypeCode === 'C') || requestType.selfPayTypeCode === 'OEC' || (selfPay.isPEBB && selfPay.isCobraSOE)" fxLayout="row"
    fxFlexFill>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Are you covered by another group dental plan?</label>
      <yes-no [name]="'coveredByOtherDental' + idx" style="width: auto;" orientation="horizontal-list"
        [stretch]="false" [(ngModel)]="currentDependent.coveredByOtherDentalInd"></yes-no>
    </kendo-formfield>
    <div class="form-inline">
      <date-picker #coveredByOtherDentalDate="ngModel" [name]="'coveredByOtherDentalDate' + idx"
        [(ngModel)]="currentDependent.coveredByOtherDentalDate">
        <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
      </date-picker>
    </div>
  </div>
  <div *ngIf="(selfPay.isSEBB && requestType.selfPayTypeCode === 'C') || requestType.selfPayTypeCode === 'OEC' || (selfPay.isPEBB && pebbVisionActive && selfPay.isCobraSOE)" fxLayout="row"
    fxFlexFill>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Are you covered by another group vision plan?</label>
      <yes-no [name]="'coveredByOtherVision' + idx" style="width: auto;" orientation="horizontal-list"
        [stretch]="false" [(ngModel)]="currentDependent.coveredByOtherVisionInd"></yes-no>
    </kendo-formfield>
    <div class="form-inline">
      <date-picker #coveredByOtherVisionDate="ngModel" [name]="'coveredByOtherVisionDate' + idx"
        [(ngModel)]="currentDependent.coveredByOtherVisionDate">
        <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
      </date-picker>
    </div>
  </div>
  <div *ngIf="requestType.selfPayTypeCode === 'C' || requestType.selfPayTypeCode === 'OEC' || (selfPay.isPEBB && (selfPay.isCobraInitial || selfPay.isCobraSOE))" fxLayout="row"
    fxFlexFill>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Do you receive Social Security Disability?</label>
      <yes-no [name]="'coveredByOtherSSD' + idx" style="width: auto;" orientation="horizontal-list"
        [stretch]="false" [(ngModel)]="currentDependent.coveredByOtherSSDInd"></yes-no>
    </kendo-formfield>
    <div class="form-inline">
      <date-picker #coveredByOtherSSDDate="ngModel" [name]="'coveredByOtherSSDDate' + idx"
        [(ngModel)]="currentDependent.coveredByOtherSSDDate">
        <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
      </date-picker>
    </div>
  </div>
  <h4 *ngIf="requestType.selfPayTypeCode === 'C' || requestType.selfPayTypeCode === 'OEC'">
    <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
    If you answered Yes to receiving Social Security Disability, you must upload or send a copy of your Social
    Security Disability Award letter. If mailing, write your last name and the last four digits of
    your Social Security number on the copy so we can identify your account. You and your enrolled dependents may be
    eligible for additional months of coverage.
  </h4>
</ng-template>

<div *ngIf="!isPebbRetireeVision && !isCobraOE && !isPebbCobraInitial && !isPebbCobraSOE && !(selfPay.isPEBB && selfPay.isRetireeSOE)">
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="25">
      <label [for]="'socialSecurityNumber' + idx">SSN</label>
      <kendo-maskedtextbox [mask]="env.ssnMask" [pattern]="env.ssnItinRegex"
        [(ngModel)]="currentDependent.socialSecurityNumber" [maskOnFocus]="true" [name]="'socialSecurityNumber' + idx"
        [id]="'socialSecurityNumber' + idx" #ssn="ngModel" class="form-control"
        [forbiddenValues]="env.invalidSSNValues"></kendo-maskedtextbox>
    </div>
    <div class="form-group" fxFlex="25">
      <date-picker #birthDate="ngModel" [name]="idx + 'birthDate'" label="Birth date" required
        [(ngModel)]="currentDependent.birthDate"></date-picker>
    </div>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40" [attr.aria-labelledby]="'birthSex' + idx + '_label'">
      <label class="k-label" [id]="'birthSex' + idx + '_label'">Sex assigned at birth<sup>1</sup></label>
      <radio-list [name]="'birthSex' + idx" [(ngModel)]="currentDependent.birthSex" required
        [items]="{ Male: 'M', Female: 'F' }"></radio-list>
    </kendo-formfield>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group required" fxFlex="50">
      <label [for]="'lastName' + idx">Last name</label>
      <input type="text" class="form-control" [id]="'lastName' + idx" [name]="'lastName' + idx"
        [(ngModel)]="currentDependent.lastName" pattern="^(?!\s)([a-zA-Z \-]){1,}$" required />
    </div>
    <kendo-formfield class="form-group required" [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Gender identity<sup>2</sup></label>
      <radio-list [name]="'genderIdentity' + idx" [(ngModel)]="currentDependent.genderIdentity"
        [items]="{ Male: 'M', Female: 'F', X: 'X' }"></radio-list>
    </kendo-formfield>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group required" fxFlex="50">
      <label [for]="'firstName' + idx">First name</label>
      <input type="text" class="form-control" [id]="'firstName' + idx" [name]="'firstName' + idx"
        [(ngModel)]="currentDependent.firstName" pattern="^(?!\s)([a-zA-Z \-]){1,}$" required />
    </div>
    <div class="form-group" fxFlex="15">
      <label [for]="'middleInitial' + idx">Middle initial</label>
      <input type="text" class="form-control" [id]="'middleInitial' + idx" [name]="'middleInitial' + idx"
        [(ngModel)]="currentDependent.middleName" pattern="^(?!\s)([a-zA-Z \-]){1,}$" />
    </div>
    <div class="form-group" fxFlex="15">
      <label [for]="'suffix' + idx">Suffix</label>
      <input type="text" class="form-control" [id]="'suffix' + idx" [name]="'suffix' + idx"
        [(ngModel)]="currentDependent.suffix" />
    </div>
  </div>
  <checkbox bold name="addressIsSameAsSubscriberInd{{index}}"
    [(ngModel)]="currentDependent.addressIsSameAsSubscriberInd">
    {{ (selfPay?.isLwopOE && selfPay?.isPEBB ? 'Street ' : (selfPay?.isLwopInitial ? 'Permantent street ' : 'Residential ')) }}address is the same as subscriber
  </checkbox>
  <div fxFill *ngIf="!currentDependent.addressIsSameAsSubscriberInd">
    <address #residentialAddress view="card" name="residentialAddress" [hideCounty]="!(selfPay.isPEBB && selfPay.isLwopOE)" [(ngModel)]="currentDependent"></address>
  </div>

  <div class="form-row" fxFlexFill>
    <div fxLayout="column" fxFlex="100">
      <div class="hca-selfPay-divider" fxFlex="45"></div>
      <span class="hca-selfPay-small-note" fxFlex="100"> 1. This field is required for health care services. </span>
      <span class="hca-selfPay-small-note" fxFlex="100">
        2. This field is not required for enrollment. Your response is optional and will be kept private to the extent allowable by law. 
        Gender X means a gender that is not exclusively male nor female. To learn more visit 
        <a target="_blank" href="https://www.hca.wa.gov/about-hca/other-administrative-activities/gender-identity-information">Gender X</a>.
        <br/><br/>
      </span>
    </div>
  </div>
  <div *ngIf="requestType.selfPayTypeCode === 'C' || (selfPay.isPEBB && (selfPay.isCobraInitial || selfPay.isCobraSOE))">
    <ng-container *ngTemplateOutlet="otherCoverage"></ng-container>
  </div>
  <div
    *ngIf="requestType.selfPayTypeCode === 'R' || requestType.selfPayTypeCode === 'OEC' || requestType.selfPayTypeCode === 'OER'">
    <div class="form-row" fxFlexFill style="margin-bottom: 20px">
      <span class="soe-form-small-header">Medicare Information</span>
      <span style="width: 100%; margin-bottom: 15px"><b>Are you enrolled in Medicare Part A or Part B?</b></span>
      <div fxLayout="row" fxFlexFill>
        <kendo-formfield [orientation]="'horizontal'" fxFlex="20">
          <label class="k-label">Part A (hospital)</label>
          <yes-no [name]="'medicarePartAEnrolledInd' + idx" style="width: auto;" orientation="horizontal-list"
            [stretch]="false" [(ngModel)]="currentDependent.medicarePartAInd"
            (ngModelChange)="updateMedicarePartA($event)"></yes-no>
        </kendo-formfield>
        <div class="form-group row">
          <date-picker #medicarePartAEffectiveDate="ngModel" [name]="'medPartADate' + idx"
            [min]="currentDependent.birthDate" [required]="currentDependent.medicarePartBInd"
            [(ngModel)]="currentDependent.medicarePartADate">
            <span class="col-form-label">If yes, enter the effective date shown on the Medicare card</span>
          </date-picker>
        </div>
      </div>
      <div fxLayout="row" fxFlexFill style="margin-top: 15px">
        <kendo-formfield [orientation]="'horizontal'" fxFlex="20">
          <label class="k-label">Part B (medical)</label>
          <yes-no [name]="'medicarePartBEnrolledInd' + idx" style="width: auto;" orientation="horizontal-list"
            [stretch]="false" [(ngModel)]="currentDependent.medicarePartBInd"
            (ngModelChange)="updateMedicarePartB($event)"></yes-no>
        </kendo-formfield>
        <div class="form-group row">
          <date-picker #medicarePartBEffectiveDate="ngModel" [name]="'medicarePartBEffectiveDate' + idx"
            [min]="currentDependent.birthDate" [required]="currentDependent.medicarePartBInd"
            [(ngModel)]="currentDependent.medicarePartBDate">
            <span class="col-form-label">If yes, enter the effective date shown on the Medicare card</span>
          </date-picker>
        </div>
      </div>
      <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
        <div class="form-group required" fxFlex="25" style="margin-top: 15px">
          <label [for]="'medicareNumber' + idx">Medicare number (HICN)</label>
          <input pattern="[a-zA-Z0-9 \-]*"
            [required]="currentDependent.medicarePartBInd || currentDependent.medicarePartAInd ? 'required' : null"
            type="text" class="form-control" [id]="'medicareNumber' + idx" [name]="'medicareNumber' + idx"
            [(ngModel)]="currentDependent.medicareNumber" />
        </div>
      </div>

      <p style="margin-top: 15px" *ngIf="!isCobra || agency != 'SEBB' || (selfPay.isPEBB && selfPay.isCobraInitial)">
        If Yes, proof is required. Upload or mail a copy of all pages of their entire Medicare benefit verification
        letter or a copy of their Medicare card if we don't already have a copy. If mailing, write your last name and
        the
        last four digits of your Social Security Number on the copy so we can identify the account. If your dependent is
        eligible for Medicare, they must enroll and stay enrolled in both Medicare Part A and Part
        B<ng-container *ngIf="!selfPay.isRetireeInitial"> to keep {{agency}} retiree health plan coverage</ng-container>.
      </p>
      <p *ngIf="selfPay.isPEBB && selfPay.isCobraSOE">
        If Yes, proof is required. Attach a copy of your Medicare benefit verification letter or a copy of your Medicare card to this form. Write your full 
        name and the last four digits of your Social Security number on the copy. You could face penalties if you don't enroll in Medicare Part A and Part B
        when you become eligible. Federal rules do not allow you to waive Medicare while on COBRA coverage.
      </p>
      <span style="width: 100%; margin-bottom: 15px" *ngIf="!selfPay.isRetireeInitial"><b>Are you enrolled in Medicare Part D (prescription drug
          coverage)?</b></span>
      <div fxLayout="row" fxFlexFill *ngIf="!selfPay.isRetireeInitial">
        <kendo-formfield [orientation]="'horizontal'" fxFlex="20">
          <yes-no [name]="'medicarePartDEnrolledInd' + idx" style="width: auto;" orientation="horizontal-list"
            [stretch]="false" [(ngModel)]="currentDependent.memberMedicare.medicarePartDEnrolledInd"></yes-no>
        </kendo-formfield>
        <div class="form-group row">
          <date-picker #medicarePartDEffectiveDate="ngModel" [name]="'medicarePartDEffectiveDate' + idx"
            [required]="currentDependent.memberMedicare.medicarePartDEnrolledInd"
            [(ngModel)]="currentDependent.memberMedicare.medicarePartDEffectiveDate">
            <span class="col-form-label">If yes, effective date</span>
          </date-picker>
        </div>
      </div>
      <p style="margin-top: 20px" *ngIf="(!isCobra || agency != 'SEBB') && !selfPay.isRetireeInitial">
        If Yes, they may enroll only in Premera Blue Cross Medicare Supplement Plan G. Plan F enrollees may stay in
        the plan. If they want to enroll in any other PEBB medical plan, they must disenroll from the Part D plan.
      </p>
      <span style="width: 100%; margin-bottom: 15px" *ngIf="!selfPay.isRetireeInitial"><b>Are you enrolled in Medicaid with Medicare Part D?</b></span>
      <div fxLayout="row" fxFlexFill *ngIf="!selfPay.isRetireeInitial">
        <kendo-formfield [orientation]="'horizontal'" fxFlex="20">
          <yes-no [name]="'medicaidMedicarePartDEnrolledInd' + idx" style="width: auto;" orientation="horizontal-list"
            [stretch]="false" [(ngModel)]="currentDependent.memberMedicare.medicaidMedicarePartDEnrolledInd"></yes-no>
        </kendo-formfield>
        <div class="form-group row">
          <date-picker #medicaidMedicarePartDEffectiveDate="ngModel" [name]="'medicaidMedicarePartDEffectiveDate' + idx"
            [required]="currentDependent.memberMedicare.medicaidMedicarePartDEnrolledInd"
            [(ngModel)]="currentDependent.memberMedicare.medicaidMedicarePartDEffectiveDate">
            <span class="col-form-label">If yes, effective date</span>
          </date-picker>
        </div>
      </div>
    </div>
    <div class="form-row" style="padding-top: 20px" fxFlexFill>
      <span class="selfPay-form-small-header">I want to enroll this dependent in</span>
      <span *ngIf="requestType.selfPayTypeCode === 'R' || requestType.selfpayTypeCode === 'OER'">
        (By choosing to enroll into coverage for yourself, your dependent(s) are automatically enrolled in the same plan
        as youyou, with some exceptions based on eligibility for Medicare Part A and Part  B.)<br/><br/>
      </span>
    </div>
    <div class="form-row" fxFlexFill style="margin-bottom: 20px">
      <div fxLayout="column" fxFlex="33" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
        <div class="k-form-field bigger" style="margin-bottom: 15px">
          <checkbox [name]="'medicalCover' + idx" [(ngModel)]="currentDependent.medicalCoverInd">Medical</checkbox>
        </div>
      </div>
      <div fxLayout="column" fxFlex="33" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
        <div class="k-form-field bigger" style="margin-bottom: 15px">
          <checkbox [name]="'dentalCover' + idx" [(ngModel)]="currentDependent.dentalCoverInd"
            [id]="'dentalCover' + idx">Dental</checkbox>
        </div>
      </div>
      <div fxLayout="column" fxFlex="33" fxFlex.fxFlex.lt-md="100"
        fxLayoutAlign="space-between">
        <div class="k-form-field bigger" style="margin-bottom: 15px">
          <checkbox [name]="'visionCover' + idx" [(ngModel)]="currentDependent.visionCoverInd" [disabled]="(!isSebbCobra && currentDependent.medicarePartBInd)"
            [id]="'visionCover' + idx">Vision</checkbox>
        </div>
      </div>
    </div>
    <div fxLayoutAlign="row">
      <span>Premium surcharges do not apply if subscriber is enrolled in Medicare Part A and Part B</span>
      <br/><br/>
    </div>
  </div>
  <div
    *ngIf="requestType.selfPayTypeCode !== 'R' && requestType.selfPayTypeCode !== 'OEC' && requestType.selfPayTypeCode !== 'OER' || isPebbLwopVision">
    <div class="form-row" style="padding-top: 20px" fxFlexFill>
      <h3 class="mobile-text-centered">Choose one box for each type of coverage</h3>
    </div>
    <div class="form-row" fxFlexFill style="margin-bottom: 20px">
      <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
        <span class="selfPay-form-small-header">Medical coverage</span>
        <radio [name]="'medicalCoverYes' + idx" radioAsCheckbox [(ngModel)]="currentDependent.medicalCoverInd"
          [value]="true" label="Cover"></radio>
        <radio [name]="'medicalCoverNo' + idx" radioAsCheckbox [(ngModel)]="currentDependent.medicalCoverInd"
          [value]="false" label="Remove from coverage"></radio>
      </div>
      <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
        <span class="selfPay-form-small-header">Dental coverage</span>
        <radio [name]="'dentalCoverYes' + idx" radioAsCheckbox [(ngModel)]="currentDependent.dentalCoverInd"
          [value]="true" label="Cover"></radio>
        <radio [name]="'dentalCoverNo' + idx" radioAsCheckbox [(ngModel)]="currentDependent.dentalCoverInd"
          [value]="false" label="Remove from coverage"></radio>
      </div>
    </div>
    <div *ngIf="agency === 'SEBB' || isPebbLwopVision" class="form-row" fxFlexFill style="margin-bottom: 20px">
      <div fxLayout="column" fxFlex="100" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
        <span class="selfPay-form-small-header">Vision coverage</span>
        <radio [name]="'visionCoverYes' + idx" radioAsCheckbox [(ngModel)]="currentDependent.visionCoverInd"
          [value]="true" label="Cover"></radio>
        <radio [name]="'visionCoverNo' + idx" radioAsCheckbox [(ngModel)]="currentDependent.visionCoverInd"
          [value]="false" label="Remove from coverage"></radio>
      </div>
    </div>
  </div>

  <div class="form-row" fxFlexFill style="margin-bottom: 20px">
    <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-between">
      <span class="selfPay-form-small-header">Tobacco {{ selfPay.isPEBB && (selfPay.isCobraOE || selfPay.isRetireeOE) ? 'uses' : 'use' }} premium surcharge</span>
      <span style="padding-bottom: 10px">
        Response required if you are enrolling dependents age 13 and older in medical coverage. If you check Yes or do
        not check any boxes below, you will be charged the $25-per-account premium
        surcharge in addition to your monthly medical premium.
        <a target="_blank" [href]="agency === 'SEBB' ? 'https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/tobacco-use-surcharge' : (selfPay.isPEBB && selfPay.isLwopOE ? 'https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/tobacco-use-surcharge' : 'https://www.hca.wa.gov/employee-retiree-benefits/retirees/tobacco-use-surcharge')">Learn
          about this surcharge before you attest.</a>

        <br />
        <br />
        <b>Does the tobacco use premium surcharge apply to you?</b> Check one:
      </span>
      <div
        *ngIf="requestType.selfPayTypeCode === 'R' || requestType.selfPayTypeCode === 'OEC' || requestType.selfPayTypeCode === 'OER' || requestType.selfPayTypeCode === 'SOER'"
        class="k-form-field bigger" style="margin-bottom: 15px">
        <checkbox [name]="'tobaccoNA_newdep' + idx" [(ngModel)]="currentDependent.surchargeNA"
          (click)="updateTobacco()">
          <b>No,</b> I am enrolled in Medicare Part A and Part B. The surcharge does not apply.
        </checkbox>
      </div>
      <div class="k-form-field bigger" style="margin-bottom: 15px">
        <radio [name]="'tobaccoYes' + idx" radioAsCheckbox [disabled]="currentDependent.surchargeNA"
          [(ngModel)]="currentDependent.tobaccoUseInd" [value]="true">
          <b>Yes,</b> I am subject to the $25 premium surcharge. This dependent has used tobacco products in the past
          two months.
        </radio>
      </div>
      <div class="k-form-field bigger" style="margin-bottom: 20px">
        <radio [name]="'tobaccoNo' + idx" radioAsCheckbox [disabled]="currentDependent.surchargeNA"
          [(ngModel)]="currentDependent.tobaccoUseInd" [value]="false">
          <b>No,</b> I am not subject to the $25 premium surcharge. This dependent has not used tobacco products in the
          past two months or has enrolled in 
          <span *ngIf="selfPay.isLwopOE" class="hca-mid-sz">
            or accessed <span *ngIf="!selfPay.isSEBB">one of the </span>
            <a target="_blank"
            [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-sebb' : 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-pebb'">
              tobacco cessation resources
            </a>.
          </span>
          <span *ngIf="!selfPay.isLwopOE" class="hca-mid-sz">
            their {{agency}} <a target="_blank"
              [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-sebb' : 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-pebb'">medical plan's tobacco
              cessation program </a> (if age 18 or older) or accessed
            information or resources on the <a target="_blank" href="https://teen.smokefree.gov/">Smokefree Teen
              website</a> (if age 13 to 17).
          </span>
        </radio>
      </div>
    </div>
  </div>
  <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between">
    <button fxFlex="30" (click)="cancelChanges()" class="btn btn-light">Cancel</button>
    <button fxFlex="30" (click)="emitSubmitDependent()" class="btn btn-primary">Save dependent</button>
  </div>

</div>


<!-- RETIREE OE 2025 -->

<form nativeControlElement #dependentForm="ngForm" #formContainer
  *ngIf="isPebbRetireeVision || isCobraOE || isPebbCobraInitial || isPebbCobraSOE || (selfPay.isPEBB && selfPay.isRetireeSOE)">
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="25">
      <label [for]="'socialSecurityNumber' + idx">SSN</label>
      <input #ssn="ngModel" type="text" class="form-control" minlength="11" maxlength="11"
        [ngModel]="(!noSSN ? currentDependent.socialSecurityNumber : null) | ssn"
        (ngModelChange)="currentDependent.socialSecurityNumber = $event?.split('-').join('')"
        [name]="'socialSecurityNumber' + idx" [id]="'socialSecurityNumber' + idx" />
    </div>
    <div class="form-group" fxFlex="25">
      <date-picker #birthDate="ngModel" [name]="'birthDate' + idx" label="Birth date"
        [(ngModel)]="currentDependent.birthDate"></date-picker>
    </div>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Sex assigned at birth<sup>1</sup></label>
      <radio-list [name]="'birthSex' + idx" [(ngModel)]="currentDependent.birthSex"
        [items]="{ Male: 'M', Female: 'F' }"></radio-list>
    </kendo-formfield>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="50">
      <label [for]="'lastName' + idx">Last Name</label>
      <input type="text" class="form-control" [name]="'lastName' + idx" [id]="'lastName' + idx"
        [(ngModel)]="currentDependent.lastName" />
    </div>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Gender Identity<sup>2</sup></label>
      <radio-list [name]="'genderIdentity' + idx" [(ngModel)]="currentDependent.genderIdentity"
        [items]="{ Male: 'M', Female: 'F', X: 'X' }"></radio-list>
    </kendo-formfield>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="50">
      <label [for]="'firstName' + idx">First Name</label>
      <input type="text" class="form-control" [id]="'firstName' + idx" [name]="'firstName' + idx"
        [(ngModel)]="currentDependent.firstName" />
    </div>
    <div class="form-group" fxFlex="15">
      <label [for]="'middleInitial' + idx">Middle Initial</label>
      <input type="text" class="form-control" [id]="'middleInitial' + idx" [name]="'middleInitial' + idx"
        [(ngModel)]="currentDependent.middleName" />
    </div>
    <div class="form-group" fxFlex="15">
      <label [for]="'suffix' + idx">Suffix</label>
      <input type="text" class="form-control" [id]="'suffix' + idx" [name]="'suffix' + idx"
        [(ngModel)]="currentDependent.suffix" />
    </div>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill
    *ngIf="currentDependent.isSpouse">
    <div class="form-group" fxFlex="25">
      <date-picker #dateOfMarriage="ngModel" [name]="'dateOfMarriage' + idx" label="Date of marriage"
        [(ngModel)]="currentDependent.partnershipStartDate"></date-picker>
    </div>
  </div>
  <checkbox bold name="addressSameAsSubscriber{{index}}" [(ngModel)]="currentDependent.addressSameAsSubscriber">
    {{ selfPay.isPEBB && selfPay.isLwopOE ? 'Street' : selfPay.isPEBB && (selfPay.isCobraOE || selfPay.isCobraInitial || selfPay.isLwopInitial) ? 'Permanent street' : 'Residential' }} address is the same as subscriber
  </checkbox>
  <div class="form-row" *ngIf="!currentDependent.addressSameAsSubscriber">
    <address #residentialAddress view="inline" name="residentialAddress"
      hideCounty="true" [(ngModel)]="currentDependent.residentialAddress"></address>
    <div *ngIf="selfPay.isPEBB && (selfPay.isCobraOE || selfPay.isCobraInitial)" style="margin-bottom: 20px;">
      PO Box not allowed. 
    </div>
    <div *ngIf="selfPay.isPEBB && selfPay.isRetireeOE" style="margin-bottom: 20px;">
      PO Box is not allowed for Medicare enrollment. 
      1. <i>This field is required for health care services. </i>
      2. <i>This field is not required for enrollment. Your response is optional and will be kept private to the extent allowable by law. Gender X means a gender that is not exclusively male nor female. To learn more visit <a target="_blank" href="https://www.hca.wa.gov/about-hca/other-administrative-activities/gender-identity-information">Gender X.</a></i>
    </div>
    <div style="margin-bottom: 20px;" *ngIf="!selfPay.isRetireeSOE && !selfPay.isRetireeOE && !(selfPay.isPEBB && selfPay.isCobraSOE)">
      Enrollment in Medicare Advantage with Part D Plans {{ selfPay?.isPEBB && selfPay?.isCobraOE ? 'or' : 'and' }} UMP Classic Medicare with Part D (PDP) has specific requirements associated with 
      residential addresses. PO boxes and out-of-country addresses will be reviewed by HCA for eligibility. 
      Proof of <span *ngIf="selfPay.isCobraOE">permanent </span>residence may need to be provided.
    </div>
    <div style="margin-bottom: 20px;" *ngIf="selfPay.isRetireeSOE">
      If you are enrolled in Medicare, this information needs to match your Medicare record to avoid delay to coverage starting.
      Proof of address may need to be provided.
    </div>
  </div>
  <div class="form-row" fxFlexFill *ngIf="!selfPay.isRetireeOE">
    <div fxLayout="column" fxFlex="100">
      <div class="hca-selfPay-divider" fxFlex="45"></div>
      <span class="hca-selfPay-small-note" fxFlex="100"> 1. This field is required for health care services. </span>
      <span class="hca-selfPay-small-note" fxFlex="100">
        2. This field is not required for enrollment. Your response is optional and will be kept private to the extent allowable by law. Gender X means a gender that is not exclusively male nor female. To learn more visit <a target="_blank" href="https://www.hca.wa.gov/about-hca/other-administrative-activities/gender-identity-information">Gender X.</a>
        <br/><br/>
      </span>
    </div>
  </div>
  <!-- COVERAGE -->
  <div>
    <div class="form-row" style="padding-top: 20px" fxFlexFill>
      <h4>Coverage options</h4>
      <span class="soe-form-small-header">Enroll dependent in (or remain enrolled)</span>
    </div>
    <div class="form-row" fxFlexFill>
      <div class="form-row" fxFlexFill style="margin-bottom: 20px">
        <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px"
            class="fxGap-medium-sm">
            <div class="k-form-field bigger" fxFlex="30">
              <checkbox name="medicalEnrollInd" [(ngModel)]="currentDependent.medicalCoverInd"
                (ngModelChange)="handleCoverageChange($event)">Medical</checkbox>
            </div>
            <div class="k-form-field bigger" fxFlex="30">
              <checkbox name="dentalEnrollInd" [(ngModel)]="currentDependent.dentalCoverInd"
                (ngModelChange)="handleCoverageChange($event)">Dental
              </checkbox>
            </div>
            <div class="k-form-field bigger" fxFlex="30">
              <checkbox name="visionEnrollInd" [(ngModel)]="currentDependent.visionCoverInd"
                (ngModelChange)="handleCoverageChange($event)" [disabled]="(!isSebbCobra && currentDependent.medicarePartBInd)">
                Vision</checkbox>
            </div>
          </div>
        </div>
        <div *ngIf="isPebbRetireeVision" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
          fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
            <span *ngIf="!selfPay.isRetireeInitial">
              Dependents will be enrolled in the same coverage as you (the subscriber). The exceptions are:
              <br />
              <br />
              <ol>
                <li>The standalone vision option is available for non-Medicare enrolled dependents if subscriber is enrolled in Medicare</li>
                <li>If you are deferring due to Medicare/Medicaid, your dependent can enroll in coverage you aren’t enrolled in. </li>
              </ol>
              <br />
              <div *ngIf="!(selfPay.isPEBB && selfPay.isCobraSOE)">Coverage that is terminated will end December 31 of the current year and could require additional forms to be submitted if enrolled in a Medicare Advantage (MA) or Medicare Advantage Prescription Drug Plan (MAPD). Also submit <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">Form D</a></div>
              <a *ngIf="selfPay.isPEBB && selfPay.isCobraSOE" target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">Form D</a>
            </span>
            <span *ngIf="selfPay.isRetireeInitial">
              Dependents can only be enrolled in the same coverages that are elected for the subscriber. The exceptions are:
              <br />
              <br />
              <ol>
                <li>Standalone vision coverage is available for non-Medicare enrolled dependents if subscriber is enrolled in Medicare.</li>
                <li>
                  <p>
                    If subscriber is deferring due to Medicare/Medicaid, the dependent can enroll in coverages the subscriber isn't also enrolled in.
                  </p>
                  <p>
                    Coverage that is terminated will end at the end of the current calendar/plan year and could require additional forms to be submitted if
                    enrolled in a Medicare Advantage (MA), Medicare Advantage Prescription Drug Plan (MAPD) or a Part D plan.
                  </p>
                </li>
              </ol>
              Response required if your are enrolling dependents age 13 and older in medical coverage.  If you check Yes or do not check any boxes below,
              you will be charged the $25-per-account premium surcharge in addition to your monthly medical premium.
            </span>
          </div>
        </div>
        <div *ngIf="selfPay.isSEBB && selfPay.isCobraOE" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
          fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
            <span>
              Choose the coverage you wish to enroll this dependent in (or remain enrolled in). If you wish to terminate
              an existing
              coverage, deselect the coverage and it will end on December 31 of the current year.
            </span>
          </div>
        </div>
        <div *ngIf="selfPay.isPEBB && selfPay.isCobraOE" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
          fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
            <span>
              <p>
                Choose the coverage you wish to enroll this dependent in (or remain enrolled in). If you wish to
                terminate existing coverage,
                deselect the coverage and it will end on December 31 of the current year.
              </p>
              <p>
                Termination of coverage from a Medicare Advantage plan (MA plan) may require an additional form. Also
                submit
                <a target="_blank"
                  href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">Form
                  D</a>
              </p>
            </span>
          </div>
        </div>
        <div *ngIf="isPebbCobraInitial || isPebbCobraSOE" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
          fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
            <span>
              Choose the coverage you wish to enroll this dependent in (or remain enrolled in). 
              <br />
              <br />
              Terminating coverage from a Medicare Advantage with Part D plan or UMP Classic Medicare with Part D (PDP) also 
              <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">requires a PEBB Medicare Plan Disenrollment form (form D)</a>
            </span>
          </div>
        </div>
      </div>
      <div class="form-row" fxFlexFill style="margin-bottom: 20px" *ngIf="selfPay.isPEBB && selfPay.isCobraSOE">
        Enrollment in Medicare Advantage Plans (MAPD) or Medicare Part D has specific requirements associated with
        residential addresses.
        PO boxes and out-of-country addresses may not be eligible for MAPD/Part D enrollment and will need to be reviewed
        by HCA for eligibility.
        Proof of residence may need to be provided.
      </div>
      <ng-container *ngIf="selfPay.isPEBB && (selfPay.isCobraInitial || selfPay.isCobraSOE)">
        <ng-container *ngTemplateOutlet="otherCoverage"></ng-container>
      </ng-container>
    </div>
  </div>
  <!-- MEDICARE -->
  <div class="form-row" fxFlexFill style="margin-bottom: 20px">
    <span class="soe-form-small-header">Medicare information</span>
    <span style="width: 100%; margin-bottom: 15px"><b>Are you enrolled in Medicare Part A or Part B?</b></span>
    <div fxLayout="row" fxFlexFill class="fxGap-large">
      <div fxLayout="column">
        <div>
          <label for="medicarePartA" class="k-label">Part A (hospital)</label>
        </div>
        <yes-no name="medicarePartA" style="width: auto;" orientation="horizontal-list" [stretch]="false"
          [required]="requestType === 'R' || requestType === 'C'" [(ngModel)]="currentDependent.medicarePartAInd"
          (ngModelChange)="updateMedicarePartA($event)" [disabled]="disableFormForNoCoverage"></yes-no>
      </div>
      <div class="form-inline">
        <div class="form-group">
          <date-picker #medicarePartADate="ngModel" name="medicarePartADate" labelFlex="70" inputFlex="30"
            [min]="currentDependent.birthDate" [required]="currentDependent.medicarePartAInd"
            [disabled]="disableFormForNoCoverage" [(ngModel)]="currentDependent.medicarePartADate">
            <span style="white-space: nowrap; margin-right: 20px">If yes, enter the effective date shown on the Medicare
              card</span>
          </date-picker>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxFlexFill style="margin-top: 15px" class="fxGap-large">
      <div fxLayout="column">
        <div>
          <label for="medicarePartB" class="k-label">Part B (medical)</label>
        </div>
        <yes-no name="medicarePartB" style="width: auto;" orientation="horizontal-list" [stretch]="false"
          [required]="requestType === 'R' || requestType === 'C'" [(ngModel)]="currentDependent.medicarePartBInd"
          [disabled]="disableFormForNoCoverage" (ngModelChange)="updateMedicarePartB($event)"></yes-no>
      </div>
      <div class="form-inline">
        <date-picker #medicarePartBDate="ngModel" name="medicarePartBDate" labelFlex="70" inputFlex="30"
          [min]="currentDependent.birthDate" [required]="currentDependent.medicarePartBInd"
          [disabled]="disableFormForNoCoverage" [(ngModel)]="currentDependent.medicarePartBDate">
          <span style="white-space: nowrap; margin-right: 20px">If yes, enter the effective date shown on the Medicare
            card</span>
        </date-picker>
      </div>
    </div>
    <div class="form-group" fxFill>
      <label for="suffix">Medicare number (11 digits)</label> <b> Please verify the accuracy of your Medicare
        Beneficiary Number (MBI)</b>
      <input [disabled]="disableFormForNoCoverage" pattern="[a-zA-Z0-9]*" type="text" class="form-control"
        id="medicareNumber" name="medicareNumber" [(ngModel)]="currentDependent.medicareNumber" minlength="11"
        maxlength="11" />
    </div>
    <p *ngIf="isPebbRetireeVision && !selfPay.isRetireeInitial">
      If Yes, proof is required. Upload or mail a copy of all pages of your Medicare benefit verification letter or a copy of your Medicare card if we don't already have a copy. If mailing, write your last name and
      the last four digits of your Social Security Number on the copy so we can identify your account. If you are eligible for Medicare, you must enroll and stay enrolled in both Medicare Part A
      and Part B to keep PEBB retiree health plan coverage.
    </p>
    <p *ngIf="selfPay.isPEBB && selfPay.isCobraInitial">
      If Yes, proof is required. Upload or mail a copy of their Medicare benefit verification letter or a
      copy of their Medicare card. Write your full name and the last four digits of your Social Security number
      on the copy. Your spouse or SRDP will not be enrolled until their proof of Medicare is received.
    </p>
    <p *ngIf="isPebbRetireeVision && selfPay.isRetireeInitial">
      If Yes, proof is required. Upload or mail a copy of all pages of their Medicare benefit verification letter or a copy of their Medicare card
      if we don't already have a copy. If mailing, write the subscribers full name and the last four digits of their Social Security Number on the
      copy so we can identify your account. If your dependent is eligible for Medicare, they must enroll and stay enrolled in both Medicare Part A
      and Part B.
    </p>
    <p *ngIf="(selfPay.isPEBB && selfPay.isCobraSOE) || selfPay.isCobraOE">
      If Yes, proof is required. Attach a copy of your Medicare benefit verification letter or a copy of your Medicare card to this form. Write your full 
      name and the last four digits of your Social Security number on the copy. You could face penalties if you don't enroll in Medicare Part A and Part B
      when you become eligible. Federal rules do not allow you to waive Medicare while on COBRA coverage.
    </p>
  </div>
  <div *ngIf="requestType.selfPayTypeCode === 'R' || requestType.selfPayTypeCode === 'OER'" fxLayoutAlign="row">
    <fa-icon fxFlex="5" [icon]="icons.faExclamationCircle" color="primary" size="1x"></fa-icon><span>Premium surcharges
      do not apply if subscriber is enrolled in Medicare Part A and Part B</span>
  </div>

  <div class="form-row" fxFlexFill style="margin-bottom: 20px">
    <div *ngIf="currentDependent.birthDate < thirteenYearsDate" fxLayout="column" fxFlex="100"
      fxLayoutAlign="space-between">
      <span class="selfPay-form-small-header">Tobacco use premium surcharge</span>
      <span style="padding-bottom: 10px">
        <span *ngIf="currentDependent.relationshipTypeName === 'Spouse/state-registered domestic partner'">
          Response required if you are enrolling your spouse or state-registered domestic partner (SRDP) in medical
          coverage. If you check Yes or do not check any boxes below, you will be charged the
          $25-per-account premium surcharge in addition to your monthly medical premium.
        </span>
        <span *ngIf="currentDependent.relationshipTypeName !== 'Spouse/state-registered domestic partner'">
          Response required if you are enrolling dependents age 13 and older in medical coverage. If you check Yes or do
          not check any boxes below, you will be charged the $25-per-account premium
          surcharge in addition to your monthly medical premium.
        </span>
        <span *ngIf="(selfPay.isCobraInitial || selfPay.isCobraOE) && !selfPay.isSEBB">
            <br/>
            <br/>
            Premium surcharges do not apply to subscribers who are enrolled in Medicare Part A and Part B. 
          </span>
        <br />
        <br />
        <b>Does the tobacco use premium surcharge apply to you?</b> Check one:
      </span>
      <div
        *ngIf="requestType.selfPayTypeCode !== 'U' && requestType.selfPayTypeCode !== 'OEU' && requestType.selfPayTypeCode !== 'SOEU' && (agency != 'SEBB' || !isCobra)"
        class="k-form-field bigger" style="margin-bottom: 15px">
        <checkbox [name]="'tobaccoNA' + idx" [(ngModel)]="currentDependent.surchargeNA"
          [disabled]="disableFormForNoCoverage" (change)="updateTobacco()">
          <b *ngIf="selfPay.isRetireeInitial">No,</b> Subscriber is enrolled in Medicare Part A and Part B. Premium surcharge does not apply.
        </checkbox>
      </div>
      <div class="k-form-field bigger" style="margin-bottom: 15px">
        <radio [name]="'tobaccoYes' + idx" [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage"
          radioAsCheckbox [value]="true" [(ngModel)]="currentDependent.tobaccoUseInd">
          <b>Yes,</b> I am subject to the $25 premium surcharge. This dependent has used tobacco products in the past
          two months.
        </radio>
      </div>
      <div class="k-form-field bigger" style="margin-bottom: 20px" class="hca-mid-sz">
        <radio [name]="'tobaccoNo' + idx" [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage"
          radioAsCheckbox [value]="false" [(ngModel)]="currentDependent.tobaccoUseInd">
          <b>No,</b> I am not subject to the $25 premium surcharge. This dependent has not used tobacco products in the
          past two months or has enrolled in or accessed one of the <a target="_blank" [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-sebb' : 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-pebb'">tobacco cessation
          resources<span *ngIf="!((selfPay.isLwopInitial || selfPay.isLwopOE) && selfPay.isPEBB)"> noted</span></a>.
        </radio>
      </div>
    </div>
  </div>

  <div *ngIf="currentDependent.relationshipTypeName === 'Spouse/state-registered domestic partner'" class="form-row"
    fxFlexFill style="margin-bottom: 20px">
    <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-between">
      <span class="selfPay-form-small-header">Spouse or state-registered domestic partner (SRDP) coverage premium
        surcharge </span>
      <span style="padding-bottom: 10px">
        Response required if you are enrolling your spouse or SRDP in medical coverage. The {{agency}} Program requires
        a $50 premium surcharge in addition to your monthly medical premium if you are
        enrolling your spouse or SRDP in {{agency}} medical and they have chosen not to enroll in another employer-based group medical plan that is comparable to PEBB's Uniform Medical Plan Classic.
        <br />
        <br />
        <b>Answer these questions for your spouse or SRDP in {{coverageYear}}:</b>
        <div fxLayout="column">
          <ol class="hca-ordered-list">
            <li><yes-no name="spouseAttestQ1" [stretch]="false" style="width: auto;" orientation="horizontal-list"
              [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
              [(ngModel)]="currentDependent.spouseAttestQ1" (change)="spousalChange(currentDependent)">
              Are you covering your spouse or SRDP in a {{agency}} medical plan?
            </yes-no></li>
          <li><yes-no name="spouseAttestQ2" [stretch]="false" style="width: auto;" orientation="horizontal-list"
              [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
              [(ngModel)]="currentDependent.spouseAttestQ2" (change)="spousalChange(currentDependent)">
              Will they be eligible for medical coverage through their employer? (If they will not
                be employed, answer No.)
            </yes-no></li>
          <li><yes-no name="spouseAttestQ3" [stretch]="false" style="width: auto;" orientation="horizontal-list"
              [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
              [(ngModel)]="currentDependent.spouseAttestQ3" (change)="spousalChange(currentDependent)">
              Will their employer offer at least one medical plan that serves their county of residence?
            </yes-no></li>
          <li><yes-no name="spouseAttestQ4" [stretch]="false" style="width: auto;" orientation="horizontal-list"
              [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
              [(ngModel)]="currentDependent.spouseAttestQ4" (change)="spousalChange(currentDependent)">
              Have they chosen not to enroll in their employer's medical coverage?
            </yes-no></li>
          <li><yes-no name="spouseAttestQ5" [stretch]="false" style="width: auto;" orientation="horizontal-list"
              [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
              [(ngModel)]="currentDependent.spouseAttestQ5" (change)="spousalChange(currentDependent)">
              Will the coverage offered by their employer not be through the PEBB Program, SEBB Program, or a TRICARE plan?<br/> 
                    Answer Yes if their employer does not offer PEBB or SEBB coverage, or a TRICARE plan. <br/>
                    Answer No if their employer offers PEBB or SEBB coverage, or a TRICARE plan.
            </yes-no></li>
          <li><yes-no name="spouseAttestQ6" [stretch]="false" style="width: auto;" orientation="horizontal-list"
              [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
              [(ngModel)]="currentDependent.spouseAttestQ6" (change)="spousalChange(currentDependent)">
              Will their share of the medical premium through their employer be less than 
              ${{ (coverageYear >= 2026 ? '137.76' : (coverageYear == 2025 ? '126.36' : '117.81'))}} per month?
            </yes-no></li>
          </ol>
        </div>
        If you answered No to any of these questions, check no below. You will not be charged the surcharge.
        If you answered Yes to all of these questions:
        <br />
        <br />
        <ol>
          <li>Ask your spouse or SRDP for the Summary of Benefits and Coverage (SBC) for all medical plans that:
            <ol type="a">
              <li>Serve their county of residence.</li>
              <li>Have a monthly premium of less than 
                ${{ (coverageYear >= 2026 ? '137.76' : (coverageYear == 2025 ? '126.36' : '117.81'))}} per month for the employee.</li>
            </ol>
          </li>
          <li>Use the SBC information to answer the questions in the {{agency}} Spousal Plan Calculator online tool. You
            will get a Yes or No response from the calculator. Enter your response below.</li>
        </ol>
        <br />
        <b>Does the spouse or SRDP coverage premium surcharge apply to you?</b> Check one:
      </span>
      <div fxlayout="row" fxFlex="100" fxLayoutAlign="space-between">
        <radio [name]="'spousalYes' + idx" radioAsCheckbox
          [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" value="Y"
          [(ngModel)]="currentDependent.spouseSurchargeTriState">
          <b>Yes,</b> I am subject to the $50 premium surcharge. I completed the {{coverageYear}}
          <a [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/school-employees/spousal-plan-calculator' : 'https://www.hca.wa.gov/employee-retiree-benefits/spousal-plan-calculator'"
            target="_blank">{{agency}} Spousal Plan Calculator</a> online.
        </radio>
        <span class="selfPay-form-small-header" fxFlex="40">
          <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
          If you check <b>Yes</b> or do not check any boxes below, you will be charged the $50 spouse or SRDP coverage
          premium surcharge.
        </span>
      </div>
      <radio [name]="'spousalNo' + idx" radioAsCheckbox
        [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" value="N"
        [(ngModel)]="currentDependent.spouseSurchargeTriState">
        <b>No,</b> I am not subject to the $50 premium surcharge. I completed the {{agency}} Spousal Plan Calculator
        online.
      </radio>
      <radio [name]="'spousalHelp' + idx" radioAsCheckbox
        [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" value="H"
        [(ngModel)]="currentDependent.spouseSurchargeTriState">
        The {{agency}} Program to help determine if premium surcharge applies. I am completing and submitting a printed
        {{agency}} Spousal Plan
        Calculator.
      </radio>
    </div>
  </div>

  <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px;">
    <button fxFlex="30" (click)="cancelChanges()" class="btn btn-light">Cancel</button>
    <button fxFlex="30" (click)="emitSubmitDependent(formContainer)" class="btn btn-primary">Save and Continue</button>
  </div>
</form>